import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorPageComponent } from '@app/shared/components/error-page/error-page.component';
import { NotFoundComponent } from '@app/shared/components/not-found/not-found.component';
import { LoggedInGuard } from '@app/shared/guards/logged-in-guard.service';

export const routes: Routes = [
  {
    path: '',
    canActivate: [LoggedInGuard],
    loadChildren: () => import('dashboard/containers/main/main.module').then((M) => M.MainModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('dashboard/modules/auth/auth.module').then((M) => M.AuthModule),
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  {
    path: 'error',
    component: ErrorPageComponent,
  },
  {
    path: '**',
    redirectTo: '/not-found',
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
})
export class AppRoutingModule {}
